import { PackBlockBox } from '@/services/api.service';
import styles from './PackForm.module.scss';

/** Éditeur d'une box Bedrock (collision / hitbox) : mode + origin/size si personnalisée. */
export function BoxEditor({
  label,
  color,
  box,
  onChange,
}: {
  label: string;
  color: string;
  box: PackBlockBox;
  onChange: (b: PackBlockBox) => void;
}) {
  const origin = box.origin ?? [-8, 0, -8];
  const size = box.size ?? [16, 16, 16];
  const setMode = (mode: string) =>
    onChange({ mode, origin: mode === 'custom' ? origin : box.origin, size: mode === 'custom' ? size : box.size });
  const setArr = (field: 'origin' | 'size', i: number, v: string) => {
    const base = (field === 'origin' ? origin : size).slice();
    base[i] = v === '' || v === '-' ? 0 : Number(v);
    onChange({ mode: 'custom', origin: field === 'origin' ? base : origin, size: field === 'size' ? base : size });
  };
  return (
    <div className={styles.field}>
      <label className={styles.label}>
        <span className={styles.boxDot} style={{ backgroundColor: color }} /> {label}
      </label>
      <select className={styles.select} value={box.mode} onChange={(e) => setMode(e.target.value)}>
        <option value="full">Complète (bloc plein)</option>
        <option value="none">Aucune</option>
        <option value="custom">Personnalisée</option>
      </select>
      {box.mode === 'custom' && (
        <div className={styles.boxGrid}>
          <span className={styles.boxAxis}>Origin</span>
          {[0, 1, 2].map((i) => (
            <input key={`o${i}`} className={styles.boxNum} type="number" value={origin[i]} onChange={(e) => setArr('origin', i, e.target.value)} />
          ))}
          <span className={styles.boxAxis}>Size</span>
          {[0, 1, 2].map((i) => (
            <input key={`s${i}`} className={styles.boxNum} type="number" value={size[i]} onChange={(e) => setArr('size', i, e.target.value)} />
          ))}
        </div>
      )}
    </div>
  );
}
